import { useMemo } from "react";
import { object, number, string } from "yup";
import { BooleanSwitchValue } from "consts/general";
import { FormField } from "./types";

const useValidationSchema = () =>
    useMemo(() => (
        object().shape({
            [FormField.HasAdverseMediaCoverage]: number()
                .nullable()
                .required(),

            [FormField.AdverseMediaCoverageInput]: string()
                .when(FormField.HasAdverseMediaCoverage, {
                    is: displayInputInvariant,
                    then: string()
                        .required()
                        .trim()
                        .min(1)
                        .label('Adverse Media Coverage Input')
                }),

            [FormField.HasLegalInvestigation]: number()
                .nullable()
                .required(),

            [FormField.LegalInvestigationInput]: string()
                .when(FormField.HasLegalInvestigation, {
                    is: displayInputInvariant,
                    then: string()
                        .required()
                        .trim()
                        .min(1)
                        .label('Legal Investigation Input')
                }),

            [FormField.HasCertification]: number()
                .nullable()
                .required(),

            [FormField.IsCompliantWithTax]: number()
                .nullable()
                .required(),

            [FormField.IsRegisteredWithAuthority]: number()
                .nullable()
                .required(),

            [FormField.RegisteredWithAuthorityInput]: string()
                .when(FormField.IsRegisteredWithAuthority, {
                    is: displayInputInvariant,
                    then: string()
                        .required()
                        .trim()
                        .min(1)
                        .label('Registered With Authority Input')
                })
        })
    ), []);

export default useValidationSchema;

function displayInputInvariant(
    value: number | null,
    switchValue = BooleanSwitchValue.On
): boolean {
    return Object.is(value, switchValue);
}
